export default "__VITE_ASSET__Dx$WJX_l__"